import { useMemo } from 'react'
import type { ISessionDetailed } from '@/modules/_misc/Session'
import type { IDigitalFileSimplified } from '@/modules/DigitalFile/DigitalFile'
import { useAuthContext } from '@/providers/Global'
import { useDigitalFile } from './useDigitalFile'

// ///////////////////////
// MARK: EXPORTS
export const useUserAvatar = (session?: ISessionDetailed): string => {
  const Auth = useAuthContext()

  const digitalFile = useDigitalFile(session ? session?.user.logo : Auth.active?.user.logo)

  return useMemo<string>(() => {
    if (digitalFile.data?.fileUrl) {
      return digitalFile.data.fileUrl
    }

    if (digitalFile.data?.base64) {
      return digitalFile.data.base64
    }

    const active = session ?? Auth.active!

    return `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(
      `${active.user.firstName} ${active.user.lastName}`,
    )}`
  }, [Auth.active, digitalFile.data, session])
}

export const useUserAvatarSimple = (
  firstName: string,
  lastName: string,
  digitalFileSimplified?: IDigitalFileSimplified,
): string => {
  const digitalFile = useDigitalFile(digitalFileSimplified)

  return useMemo<string>(() => {
    if (digitalFile.data?.fileUrl) {
      return digitalFile.data.fileUrl
    }

    if (digitalFile.data?.base64) {
      return digitalFile.data.base64
    }

    return `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(
      `${firstName} ${lastName}`,
    )}`
  }, [digitalFile.data?.base64, digitalFile.data?.fileUrl, firstName, lastName])
}
